import { translate } from '~/scripts/locales/translations';

export default function beforeUnload() {
  return {
    unsavedChanges: false,

    init() {
      this.$el.addEventListener('tinymcechange', () => this.setBeforeUnload());
      this.beforeUnloadHandler = this.beforeUnloadHandler.bind(this);
    },

    beforeUnloadHandler(event) {
      if (this.unsavedChanges) {
        const discardUnsavedChangesMsg = translate('before-unload', 'warning-message', document.documentElement.lang);

        if (window.confirm(discardUnsavedChangesMsg)) {
          this.unsavedChanges = false;
        } else {
          event.preventDefault();
        }
      }
    },

    // 'close-modal-with-changes' is a custom event fired by the modal component
    setBeforeUnload() {
      if (this.unsavedChanges) return;
      this.unsavedChanges = true;
      window.addEventListener('beforeunload', this.beforeUnloadHandler);
      window.addEventListener('turbo:before-visit', this.beforeUnloadHandler);
      window.addEventListener('close-modal-with-changes', this.beforeUnloadHandler);
    },

    unsetBeforeUnload() {
      this.unsavedChanges = false;
      window.removeEventListener('beforeunload', this.beforeUnloadHandler);
      window.removeEventListener('turbo:before-visit', this.beforeUnloadHandler);
      window.removeEventListener('close-modal-with-changes', this.beforeUnloadHandler);
    },

    form: {
      ['x-on:input']() {
        this.setBeforeUnload();
      },
      ['x-on:submit']() {
        this.unsetBeforeUnload();
      },
    },

    googleMaps: {
      ['x-on:click']() {
        this.setBeforeUnload();
      },
    },
  };
}
